import React, { useState } from 'react';
import 'moment/locale/pt';
import { Box, Button, FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { enqueueSnackbar } from 'notistack';
import { PutFetch, urls } from '../../../../services/apiBase';

export default function EditModal({ agreement, onClose, getList }) {

  const [load, setLoad] = useState(false);
  const [amount, setAmount] = useState(agreement.value_rate);

  const handleOnCloseModal = () => {
    onClose();
  }

  const handleSaveEditedValues = async (e) => {
    setLoad(true);
    try {
      await PutFetch(urls.PUT_BOI_GORDO, { id: agreement.id, price: amount });
      getList();
      handleOnCloseModal();
      enqueueSnackbar('Alteração salva com sucesso!', { variant: 'success' });
      
    } catch (error) {
     enqueueSnackbar("Erro ao realizar alteração!", { variant: "error" });
    } finally {
      setLoad(false);
    }
  }

  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        boxShadow: 24,
        borderRadius: 2,
        backgroundColor: grey[300],
      }}
    >
      <Box
        sx={{
          padding: "16px",
          borderRadius: "8px 8px 0 0",
          backgroundColor: "#fff",
        }}
      >
        <Typography variant="h6" component="h2">
          Editar {agreement.nome}
        </Typography>
      </Box>

      <Box
        sx={{
          marginTop: "16px",
          marginBottom: "16px",
          marginRight: "32px",
          width: 400,
          minWidth: 400,
          maxHeight: "80%",
          height: "90%",
          width: "100%",
          backgroundColor: "#fff",
          borderRadius: 1,
          display: "flex",
          flexDirection: "column",
          padding: 2,
          gap: 2,
        }}
      >
        <FormControl fullWidth>
          <InputLabel htmlFor="outlined-adornment-amount">
            Valor do investimento
          </InputLabel>
          <OutlinedInput
            required
            id="outlined-adornment-amount"
            type="number"
            startAdornment={
              <InputAdornment position="start">R$</InputAdornment>
            }
            label="Valor do investimento"
            value={amount}
            onChange={(event) => {
              setAmount(event.target.value);
            }}
          />
        </FormControl>
      </Box>

      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "flex-end",
          gap: 1,
          padding: 2,
          borderRadius: "0 0 8px 8px",
          backgroundColor: "#fff",
        }}
      >
        <Button variant="contained" color={"success"} disabled={load}>
          <Typography color={"#fff"} onClick={() => handleSaveEditedValues()}>
            {load ? 'Salvando...' : 'Salvar'}
          </Typography>
        </Button>
        <Button variant="contained" color="error" onClick={onClose}>
          <Typography color={"#fff"}>Fechar</Typography>
        </Button>
      </Box>
    </Box>
  );
}
